<suvo-users-card-entry label="First Name" [entryControl]="basicsForm?.controls.firstName" (entrySaved)="onEntrySaved()">
</suvo-users-card-entry>

<mat-divider></mat-divider>

<suvo-users-card-entry label="Last Name" [entryControl]="basicsForm?.controls.lastName" (entrySaved)="onEntrySaved()">
</suvo-users-card-entry>